import { useTheme } from "@emotion/react";
import PropTypes from "prop-types";
import useBreakpoints from "../../util/breakpoints";

const Text = ({ color, children, css, stylesOverride, ...props }) => {
  const theme = useTheme();

  const breakCss = useBreakpoints()({ fontSize: theme.typography.copy.sizes });

  const style = {
    margin: theme.typography.copy.margin,
    //fontFamily: theme.typography.copy.fontFamily,
    //fontWeight: theme.typography.copy.fontWeight,
    //lineHeight: theme.typography.copy.lineHeight,
    letterSpacing: theme.typography.copy.letterSpacing,
    color: theme.colors.text[color][theme.variant]
  };

  return (
    <div css={[style, breakCss, css, stylesOverride]} {...props}>
      {children}
    </div>
  );
};

Text.defaultProps = {
  color: "base",
  stylesOverride: []
};

Text.propTypes = {
  color: PropTypes.oneOf([
    "brand",
    "primary",
    "base",
    "based",
    "secondary",
    "success",
    "error",
    "warning",
    "info",
  ]),
  children: PropTypes.node,
  css: PropTypes.array,

  stylesOverride: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ])
};

export default Text;
